// nav路由
import order from './order'

const navs = [
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '首页',
      type: 'menu'
    },
    component: () => import('@/views/Home')
  },
  {
    path: '/course',
    name: 'course',
    meta: {
      title: '课程中心',
      type: 'menu'
    },
    component: () => import('@/views/CourseCenter'),
    children: [{
      path: 'detail',
      name: 'courseDetail',
      meta: {
        title: '课程详情',
        type: 'menu',
        hidden: true
      },
      component: () => import('@/views/CourseDetail'),
      children: [
        ...order
      ]
    }]
  },
  {
    path: '/customized',
    name: 'customized',
    meta: {
      title: '定制化咨询',
      type: 'menu',
      hidden: true
    },
    component: () => import('@/views/Home/customized.vue')
  }
]

export default navs
